import { useRouter } from "next/navigation";
import { useApi } from "@/contexts/api";
import { useAuth } from "@/contexts/auth";
import { useMessageModal } from "@/contexts/layout/message-modal-context";
import { useSeqLog } from "@/hooks/telemetry";
import { QUERY_STATUS } from "@/types/async-protocol";

const REF_CLICK_DEBUG_FLOW = "ref-click-debug";
const SDP_LOG_COMPONENT_NAME = "SessionDataProvider";
const HALT_STATUS_DEBUG_COMPONENT = "HaltStatusDebug";

export interface SessionProviderPlatform {
  api: ReturnType<typeof useApi>;
  router: ReturnType<typeof useRouter>;
  showMessageModal: ReturnType<typeof useMessageModal>["showMessageModal"];
  authLoading: boolean;
  userId: string | null;
  refClickLog: ReturnType<typeof useSeqLog>;
  haltStatusDebugLog: ReturnType<typeof useSeqLog>;
}

export function useSessionProviderPlatform(input: {
  sessionId: string;
}): SessionProviderPlatform {
  const { sessionId } = input;
  const api = useApi();
  const router = useRouter();
  const { showMessageModal } = useMessageModal();
  const auth = useAuth();
  const refClickLog = useSeqLog(SDP_LOG_COMPONENT_NAME, {
    flow: REF_CLICK_DEBUG_FLOW,
  });
  const haltStatusDebugLog = useSeqLog(HALT_STATUS_DEBUG_COMPONENT, {
    sessionId,
  });
  const user = auth.data?.user ?? null;
  const authLoading = auth.status === QUERY_STATUS.Loading;
  const userId = user?.id ?? null;

  return {
    api,
    router,
    showMessageModal,
    authLoading,
    userId,
    refClickLog,
    haltStatusDebugLog,
  };
}
